import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };

  let baseURL = `${URI_TARIFF_PLAN}reversion`;

  const query = Object.keys(payload)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
    .join('&');

  baseURL += `?${query}`;

  try {
    const userLoginInfoResult = await fetch(baseURL, opts);
    const jsonResult = await userLoginInfoResult.json();
  
    if (jsonResult.errors) {
      return Promise.reject(jsonResult.errors);
    }
    return jsonResult; 
  } catch(error) {
    return Promise.reject(error);
  }
};
